import { css } from '@emotion/react';
import { UIColorPalette } from './ColorPalette';
import HoverCardStore, { HoverCardRenderer } from './HoverCardStore';
import { MStyles } from './mobile_ui/MStyles';

export function CardNameView(props: {
  card: any;
  renderer: HoverCardRenderer;
  className?: string;
  style?: React.CSSProperties;
}) {
  const onMouseEnter = () => {
    HoverCardStore.setPosition('bottom-right-offset');
    HoverCardStore.setCard(props.card, props.renderer);
  };

  const onMouseLeave = () => {
    HoverCardStore.setCard(null, null);
  };

  const onTouchStart = (e: React.TouchEvent) => {
    onMouseEnter();
  };

  const onTouchEnd = (e: React.TouchEvent) => {
    e.preventDefault();
    onMouseLeave();
  };

  return (
    <span
      css={CardNameStyle}
      className={props.className}
      style={props.style}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onTouchStart={onTouchStart}
      onTouchEnd={onTouchEnd}
    >
      {props.card.name}
    </span>
  );
}
const CardNameStyle = css(
  {
    fontWeight: 'bold',
    color: UIColorPalette.cardNameLink,
    textDecoration: 'underline',
    '&:hover': {
      color: UIColorPalette.cardNameLinkHover,
    },
  },
  MStyles.touchableMatch,
);
